import React from 'react'
import { tracking } from '../../../../utils/tracking'
import { NewButton } from '../NewButton'
import styles from './StartupGaining.module.css'
const cards = [
   {
      title: 'Brand Exposure',
      tittleColor: '#7A129E',
      content1: 'Selected startups will pitch to VCs, corporate VCs, angel investors, industry executives, decision-makers, press, and corporate development officers.',
      content2: 'The Venture Summit will help you get noticed by the right people and drive brand awareness at an accelerated rate.',
      img: '../../assets/events/etvs23/startupsExposure.png',
   },
   {
      title: 'Immersive Learning',
      tittleColor: '#BC15BF',
      content1: 'Attending panels and participating in workshops on the main stage will impart valuable insight into the do’s and don’ts of scaling your business.',
      content2: 'Learn from leading investors and successful tech professionals, and leading business development executives.',
      img: '../../assets/events/etvs23/startupsLearn.png',
   },
   {
      title: 'Smart Money',
      tittleColor: '#CF1B9D',
      content1: 'Beyond the money, Investors that attend the Venture Summit bring years of expertise, wide networks, and massive support infrastructure. These investors advise their startups and are dedicated to seeing them succeed.',
      content2: '',
      img: '../../assets/events/etvs23/startupsPresent.png',
   },
   {
      title: 'Venture Summit',
      tittleColor: '#CF1B5B',
      content1: ' Networking opportunities are built into the entirety of the Venture Summit. Start networking before the event with the dedicated matchmaking app – reach out to investors, professionals in your field of expertise, and find potential leads.',
      content2: '',
      img: '../../assets/events/etvs23/startupsNetwork.png',
   },
];
export const StartupGaining = () => {
   return (
      <section className={styles.startupGaining}>
         <h2 >What you get from the
            <span> Venture Summit</span>
         </h2>
         <div className={styles.cards}>
            {
               cards.map((card, cardIdx) =>
                  <div key={cardIdx} className={styles.card}>
                     <img src={card.img} alt="venture summit" width={'100%'} />
                     <h3 style={{ color: card.tittleColor }}>{card.title}</h3>
                     <p>{card.content1}</p>
                     <p>{card.content2}</p>
                  </div>
               )
            }

         </div>
         <div className={styles.btn}>
            <a href='https://account.youngstartup.com' onClick={() => tracking(285)} >
               <NewButton name='APPLY NOW' color='white' bgColor='#CF1B5B' borderColor='none' fontSize />
            </a>
         </div>
      </section>
   )
}
